import { useState, useEffect } from 'react'
import AuthService from 'services/auth'
import cutileiApi from 'services/cutileiApi'
import { logApiError } from 'services/apiError'
import AlertDialog from '../AlertDialog'
import { useNavigate } from 'react-router-dom'
import { ReactComponent as Loading } from 'icons/loading2.svg'
import * as FA from 'react-icons/fa'
import { DateTime } from 'luxon'

import { 
  Container,
  Row,
  SubTitle,
  InfoText,
  MoneyTextMask,
  DangerButton
} from './styles'

export default function Bill ({ data: bill }) {
  const [loading, setLoading] = useState (false)
  const [showMore, setShowMore] = useState (false)
  const [showAlertDialog, setShowAlertDialog] = useState (false)
  const [lastCharge, setLastCharge] = useState (null)
  const token = AuthService.getToken ()
  const navigate = useNavigate ()

  const STATUS_LIST = {
    paid: 'Paga',
    pending: 'A pagar',
    canceled: 'Cancelada'
  }

  const requestConfig = {
    headers: {
      'Authorization': `Bearer ${token}`
    }
  }

  useEffect (() => {
    getLastCharge ()
  }, [showMore])

  const toggleShowMore = () => setShowMore (!showMore)
  const toggleAlertDialog = () => setShowAlertDialog (!showAlertDialog)

  const getLastCharge = async () => {
    if (!showMore) return
    setLoading (true)
    
    try {
      const { data: charges } = await cutileiApi.get (
        `/charges?bill_id=${bill.code}`, requestConfig
      )

      setLastCharge (charges[0])
    } catch (error) {
      logApiError (error)
    } finally {
      setLoading (false)
    }
  }

  const refundBill = async () => {
    try {
      await cutileiApi.delete (`/charges/${lastCharge.id}`, requestConfig)
      navigate ('/business', { replace: true })
    } catch (error) {
      logApiError (error)
    }
  }

  return (
    <Container onClick={toggleShowMore}>
      <Row>
        <SubTitle>{bill.member.name}</SubTitle>
        <Row>
          <MoneyTextMask value={parseFloat (bill.amount)}/>
          {showMore ? (
            <FA.FaChevronUp size={15} color='#252525'/>
          ) : (
            <FA.FaChevronDown size={15} color='#252525'/>
          )}
        </Row>
      </Row>
      {showMore && (
        loading ? <Loading/> : (
          <>
            <Row style={{marginTop: 10}}>
              <Row>
                <SubTitle>Status:</SubTitle>
                <InfoText>{STATUS_LIST[bill.status]}</InfoText>
              </Row>
              <Row>
                <SubTitle>Plano:</SubTitle>
                <InfoText>{bill.subscription.plan.name}</InfoText>
              </Row>
            </Row>
            <Row style={{marginTop: 10}}>
              <Row>
                <SubTitle>Gerada em:</SubTitle>
                <InfoText>
                  {DateTime.fromISO (bill.created_at).toFormat ('dd/MM/yyyy - H:mm')}
                </InfoText>
              </Row>
              <Row>
                <InfoText>Última cobrança:</InfoText>
                <SubTitle>
                  {DateTime.fromISO (lastCharge?.created_at).toFormat ('dd/MM/yyyy - H:mm')}
                </SubTitle>
              </Row>
            </Row>
            <Row style={{marginTop: 10}}>
              <DangerButton onClick={toggleAlertDialog}>
                Estornar
              </DangerButton>
            </Row>
          </>
        )
      )}
      <AlertDialog
        visible={showAlertDialog}
        title='Atenção!'
        message='Deseja realmente estornar esta fatura?'
        confirmText='Sim'
        cancelText='Não'
        onConfirm={refundBill}
        onClose={toggleAlertDialog}
        dangerous
      />
    </Container>
  )
}
